<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>施工管理</el-breadcrumb-item>
      <el-breadcrumb-item>开单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
            &nbsp;
        </el-col>
        <el-col :span="14">
          <el-button type="primary" @click="get_order_add" v-if="true" style="font-size: 15px;">添加订单</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <orderList ref="orderListRef" :paizhao="paizhao" :caozuo_type="1" :query_flag="1" :add_flag="1" :order_type="0" :shangcheng_flag="0"   :key="datekey"  >
      </orderList>
        </el-col>
      </el-row>
      <!-- 分页 -->
 
      <el-dialog :title="kaidan_title"  :visible.sync="addDialogVisible" width="95%"   @close="addDoalogClosed" >
        <kaidanAdd ref="kaidanAddRef" @orderOver="orderOver" @kaidan_addClose="kaidan_addClose" :key="datekey" >   </kaidanAdd>
      </el-dialog>
      <el-dialog :title="kaidan_title"  :visible.sync="infoDialogVisible" width="95%"   >
        <kaidanFunc ref="kaidanFuncRef" :orderInfo="orderInfo" show_type="cheliang_info" :diaoyongType="1" :key="datekey" > </kaidanFunc>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
import kaidanAdd from './module/kaidan_add.vue'
import kaidanFunc from './module/func.vue'
import orderList from './module/order_list.vue'
export default {
  components: {
    orderList: orderList,
    kaidanAdd: kaidanAdd,
    kaidanFunc: kaidanFunc
  },
  data() {
    return {
      kaidan_title: '运营开单',
      order_type01: 0,
      orderInfo: {},
      datekey: Date.now(),
      paizhao: '',
      addDialogVisible: false,
      infoDialogVisible: false,
      jiesuanDialogVisible: false

    }
  },
  created() {
 
  },
  methods: {
  
    async get_jiesuan_add() {
      this.jiesuanDialogVisible = true;
    },
    // orderOver(data) {
    //   // console.log(808)
    //   this.addDialogVisible = false
    //   this.getorderList();
    // },
    addDoalogClosed() {
      this.$refs.kaidanAddRef.input_init();
    },
    getorderList() {
      this.$refs.orderListRef.getorderList_flush()
    },
    orderOver(data) {
      console.log(808)
      this.addDialogVisible = false
      this.getorderList();
    },
    kaidan_addClose(data) {
       this.addDialogVisible = false
       this.getorderList();
    },
    get_order_add() {
      this.addDialogVisible = true
      this.datekey = Date.now()
    }
    
  }
}

</script>
<style lang="less" scoped></style>
